import { useEffect, useState, type ReactNode } from 'react';

/**
 * Renders children only after first client mount. Used to keep components
 * with browser-only deps (react-pdf, anything that touches Worker/document
 * at module load) out of the SSR render path while still showing a stable
 * placeholder in the SSR'd HTML.
 *
 * Lazy() + Suspense doesn't work for this purpose because renderToString
 * abandons the Suspense subtree and bails up to the nearest boundary,
 * which on a route page means nothing else renders either.
 */
export function ClientOnly({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  if (!mounted) return <>{fallback}</>;
  return <>{children}</>;
}
